export default function WhyWorkHere() {
  const reasons = [
    {
      icon: 'ri-global-line',
      title: 'Global Impact',
      description: 'Work on projects that connect businesses and people across 50+ countries, making a real difference in global trade.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Innovation First',
      description: 'Be at the forefront of logistics technology with AI-powered routing, real-time tracking, and cutting-edge solutions.'
    },
    {
      icon: 'ri-team-line',
      title: 'Diverse Team',
      description: 'Collaborate with talented professionals from around the world in an inclusive, multicultural environment.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Career Growth',
      description: 'Access continuous learning opportunities, mentorship programs, and clear paths for advancement.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Work-Life Balance',
      description: 'Enjoy flexible working arrangements, generous time off, and a culture that values your wellbeing.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustainability Focus',
      description: 'Contribute to our carbon-neutral shipping initiatives and help build a more sustainable future.'
    }
  ];

  return (
    <section id="culture" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Work at TrackVerse?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're more than just a logistics company. We're a community of innovators, problem-solvers, and global citizens working together to transform international shipping.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {reason.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
